import { h, Component } from 'preact';
import SchemaObject from 'components/pageSettings/schemaObject';
import * as jsonPointer from 'utils/jsonPointer';
import Store from 'store/store';
import Button from 'components/button/button';
import s from 'components/pageSettings/schema.sss';

export default class Schema extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
		};
		this.setSchema = this.setSchema.bind(this);
	}

	setSchema() {
		const schemaInput = document.getElementById('schemaInput').value;
		try {
			const parsedSchema = JSON.parse(schemaInput);
			jsonPointer.set(Store.get().data, this.props.basePath, parsedSchema);
			this.setState({ error: null });
		} catch (e) {
			this.setState({ error: 'Error: Invalid JSON' });
		}
	}

	render(props) {
		const schema = jsonPointer.get(Store.get().data, props.basePath) || {};
		return (
			<div>
				<div class={s.input}>
					<div class={s.name}>Import from JSON</div>
					<textarea 
						class={s.field} 
						rows={props.rows || 6} 
						id="schemaInput" 
						placeholder={'Paste schema JSON here'} 
					/>
					<Button primary icon="home" type="button" onClick={() => this.setSchema()}>
						Import from JSON
					</Button>
					{this.state.error && <div class={s.errorText}>{this.state.error}</div>}
				</div>
				<div class={s.schemaFields}>
					<SchemaObject
						data={schema}
						path={this.props.basePath}
					/>
				</div>
			</div>
		);
	}
}